var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2091 0C18.6263 0 14.8981 3.72814 14.8981 8.31094C14.8981 12.8937 18.6263 16.6219 23.2091 16.6219C27.7919 16.6219 31.52 12.8937 31.52 8.31094C31.52 3.72814 27.7919 0 23.2091 0ZM22.2856 12.387L18.8624 8.96384L20.1682 7.65804L22.2856 9.77545L26.2499 5.81116L27.5557 7.11696L22.2856 12.387Z",
    fill: "#57B8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54062 30.9791V25.918H0.541077L5.54062 30.9791Z",
    fill: "#2776CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5303 18.5304H3.69375V16.6835H17.369C16.6171 16.1597 15.9481 15.5393 15.363 14.8366H3.69375V12.9897H14.1498C13.8472 12.4035 13.6044 11.7883 13.4197 11.1429H3.69375V9.296H13.0779C13.0496 8.98746 12.9897 8.68831 12.9897 8.37256C12.9897 6.70917 13.3995 5.14245 14.111 3.75537H0V24.071H7.3875V31.5201H22.2241V18.4835C20.9029 18.3637 19.6577 17.9842 18.5303 17.4061V18.5304ZM18.5303 25.9179H9.23438V24.071H18.5303V25.9179ZM18.5303 22.2241H9.23438V20.3772H18.5303V22.2241Z",
    fill: "#2776CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_10043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.52,
    height: 31.52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDetails);
export default __webpack_public_path__ + "static/media/CaseDetails.276234eab9121e0e92b4461763e4af88.svg";
export { ForwardRef as ReactComponent };